module.exports = __webpack_public_path__ + "static/media/select_translation_ru.cf42913c.jpg";